import {Component, HostListener, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {HttpService} from '../../../../core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {SelectionModel} from '@angular/cdk/collections';
import {Constants} from '../../../../core/services/constants.service';
import {PropertyFpDialogComponent} from '../property-floor-plan-dialog/property-fp-dialog.component';
import {PropertyDetailDialogComponent} from './property-detail-dialog/property-detail-dialog.component';
import {
  UpdatePropertyStatusDialogComponent
} from './update-property-status-dialog/update-property-status-dialog.component';
import {MatRangeSliderComponent} from '../../../../shared/components/range-slider/range-slider.component';
import {AddPropertyDialogComponent} from './add-property-dialog/add-property-dialog.component';
import {MatTabGroup} from '@angular/material/tabs';
import {ProjectDetailTabService} from 'src/app/core/services/projectDetailTab.service';
import {ImagePreviewComponent} from 'src/app/shared/components/dialog/image-preview/image-preview.component';
import {environment} from '../../../../../environments/environment';
import {
  EditPackagePropertyDialogComponent
} from '../../edit/packages/property-package/edit-package-property-dialog/edit-package-property-dialog.component';
import {AllocateDialogComponent} from './allocate-dialog/allocate-dialog.component';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-detail-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss'],
})
export class PropertiesComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public tabService: ProjectDetailTabService,
    private httpService: HttpService,
    private toastrService: ToastrService,
  ) {
  }

  @Input() project: any;

  @ViewChild('matRangeSlider') private matRangeSlider: MatRangeSliderComponent<any>;
  @ViewChild('childTabs') childTabs: MatTabGroup;

  @Output() resetInit = new EventEmitter<string>();


  mode = 'grid';
  properties = [];
  buildings = [];
  // 列表和矩阵数据
  dataSource = new Map();

  displayedColumns = ['select', 'unit', 'floor', 'product', 'aspect', 'internalArea', 'externalArea 1',
    'externalArea 2', 'price', 'pricePerArea', 'status', 'floorPlan'];
  constants = Constants;

  // 加个搜索 slider 组件最大最小值
  minPrice = 0;
  maxPrice = 0;
  // 搜索参数
  filterParams: any;
  selected = 'any';
  selectList: any[] = ['any', 'Highest floor', 'Lowest floor', 'floor 0 - 10', 'Starfloor 11 - 20', 'floor 21 - 30', 'floor 31 - 40', 'floor 41 - 50'];
  selectedMinBedrooms = 0;
  selectedMaxBedrooms = 0;
  selectedMinBathrooms = 0;
  selectedMaxBathrooms = 0;
  selectedMinCarspace = 0;
  selectedMaxCarspace = 0;
  selectedMinPriceRange = 0;
  selectedMaxPriceRange = 0;
  isLoading = true;
  // 默认的搜索参数
  defaultFilterParams = {
    bedRoom: [
      {value: 0, label: 'Any', isChecked: true},
      {value: 1, label: '1', isChecked: false},
      {value: 2, label: '2', isChecked: false},
      {value: 3, label: '3', isChecked: false},
      {value: 4, label: '4', isChecked: false},
      {value: 5, label: '5', isChecked: false},
      {value: 6, label: '6', isChecked: false},
      {value: 7, label: '7', isChecked: false},
      {value: 8, label: '8', isChecked: false},
      {value: 9, label: '9', isChecked: false},
      {value: 10, label: '10', isChecked: false},
      {value: 11, label: '11', isChecked: false},
      {value: 12, label: '12', isChecked: false},
      {value: 1000000, label: '12+', isChecked: false},
    ],
    bathRoom: [
      {value: 0, label: 'Any', isChecked: true},
      {value: 1, label: '1', isChecked: false},
      {value: 2, label: '2', isChecked: false},
      {value: 3, label: '3', isChecked: false},
      {value: 4, label: '4', isChecked: false},
      {value: 5, label: '5', isChecked: false},
      {value: 6, label: '6', isChecked: false},
      {value: 7, label: '7', isChecked: false},
      {value: 8, label: '8', isChecked: false},
      {value: 9, label: '9', isChecked: false},
      {value: 10, label: '10', isChecked: false},
      {value: 11, label: '11', isChecked: false},
      {value: 12, label: '12', isChecked: false},
      {value: 1000000, label: '12+', isChecked: false},
    ],
    carParking: [
      {value: 0, label: 'Any', isChecked: true},
      {value: 1, label: '1', isChecked: false},
      {value: 2, label: '2', isChecked: false},
      {value: 3, label: '3', isChecked: false},
      {value: 4, label: '4', isChecked: false},
      {value: 5, label: '5', isChecked: false},
      {value: 6, label: '6', isChecked: false},
      {value: 7, label: '7', isChecked: false},
      {value: 8, label: '8', isChecked: false},
      {value: 9, label: '9', isChecked: false},
      {value: 10, label: '10', isChecked: false},
      {value: 11, label: '11', isChecked: false},
      {value: 12, label: '12', isChecked: false},
      {value: 1000000, label: '12+', isChecked: false},
    ],
    // priceRange: {
    //     min: 0,
    //     max: 0,
    // },
    priceRange: [
      {value: 0, label: 'Any', isChecked: true},
      {value: 50000, label: '$50,000', isChecked: false},
      {value: 75000, label: '$75,000', isChecked: false},
      {value: 100000, label: '$100,000', isChecked: false},
      {value: 125000, label: '$125,000', isChecked: false},
      {value: 150000, label: '$150,000', isChecked: false},
      {value: 175000, label: '$175,000', isChecked: false},
      {value: 200000, label: '$200,000', isChecked: false},
      {value: 225000, label: '$225,000', isChecked: false},
      {value: 250000, label: '$250,000', isChecked: false},
      {value: 275000, label: '$275,000', isChecked: false},
      {value: 300000, label: '$300,000', isChecked: false},
      {value: 350000, label: '$350,000', isChecked: false},
      {value: 375000, label: '$375,000', isChecked: false},
      {value: 400000, label: '$400,000', isChecked: false},
      {value: 425000, label: '$425,000', isChecked: false},
      {value: 450000, label: '$450,000', isChecked: false},

      {value: 475000, label: '$475,000', isChecked: false},
      {value: 500000, label: '$500,000', isChecked: false},
      {value: 550000, label: '$550,000', isChecked: false},
      {value: 600000, label: '$600,000', isChecked: false},
      {value: 650000, label: '$650,000', isChecked: false},

      {value: 700000, label: '$700,000', isChecked: false},
      {value: 750000, label: '$750,000', isChecked: false},
      {value: 800000, label: '$800,000', isChecked: false},
      {value: 850000, label: '$850,000', isChecked: false},
      {value: 900000, label: '$900,000', isChecked: false},

      {value: 950000, label: '$950,000', isChecked: false},
      {value: 1000000, label: '$1,000,000', isChecked: false},
      {value: 1100000, label: '$1,100,000', isChecked: false},
      {value: 1200000, label: '$1,200,000', isChecked: false},
      {value: 1300000, label: '$1,300,000', isChecked: false},
      {value: 1400000, label: '$1,400,000', isChecked: false},
      {value: 1500000, label: '$1,500,000', isChecked: false},
      {value: 999999999999999, label: '$1,500,000+', isChecked: false},
    ],
    aspect: [
      {value: 2, label: 'South', isChecked: false},
      {value: 3, label: 'East', isChecked: false},
      {value: 1, label: 'North', isChecked: false},
      {value: 4, label: 'West', isChecked: false},
      {value: 7, label: 'Southeast', isChecked: false},
      {value: 8, label: 'Southwest', isChecked: false},
      {value: 5, label: 'Northeast', isChecked: false},
      {value: 6, label: 'Northwest', isChecked: false},
    ],
    status: [
      {value: [0], label: 'Unavailable', isChecked: false},
      {value: [1], label: 'Available', isChecked: false},
      {value: [2, 3], label: 'Reserved', isChecked: false},
      {value: [4, 5], label: 'Processing', isChecked: false},
      {value: [6], label: 'Sold', isChecked: false},
    ],
  };
  // 关键词搜索
  keywords = '';
  // 是否有搜索条件
  isFiltered = false;
  dataSourceCount = 0;
  showStatusBar = false;
  // 勾选的property
  selectedProperties = [];
  // 当前的 building
  currentBuildingId: any;
  windowHeight: number;
  agencyIds: number[] = [];

  // public parseFloat = parseFloat;

  ngOnInit(): void {
    this.httpService.getProjectDetailByProjectId(this.project.id)
      .subscribe((res: any) => {
        console.log(res.data, 'getProjectDetailByProjectId');
        this.project = res.data;

        // 兼容老数据，没有 building 的project，添加一个默认的
        if ((this.project.properties && this.project.properties.length > 0) ||
          (this.project.lots && this.project.lots.length > 0) ||
          (this.project.projectTypes[0].id === 4 && !this.project.buildings)
        ) {
          const fakeBuilding = JSON.parse(JSON.stringify(this.project));
          // fakeBuilding.name = 'Main';
          this.project.buildings = this.project.buildings ? [fakeBuilding].concat(this.project.buildings) : [fakeBuilding];
        }

        this.buildings = this.project.buildings ? JSON.parse(JSON.stringify(this.project.buildings)).sort(this.compareUnit) : [];

        this.updateSourceData(this.buildings);

        if (this.buildings.length) {
          this.properties = this.buildings.map((building) => {
            return building.properties ? building.properties : [];
          }).reduce((a, b) => a.concat(b));

          // 搜索价格范围
          const priceArray = this.properties.map((property) => property.price);
          console.log(this.properties, 'properties');
          this.minPrice = Math.min(...priceArray);
          this.maxPrice = Math.max(...priceArray);
          // this.defaultFilterParams.priceRange.min = this.minPrice;
          // this.defaultFilterParams.priceRange.max = this.maxPrice;
        }

        this.filterParams = JSON.parse(JSON.stringify(this.defaultFilterParams));
        this.isLoading = false;
      });

  }

  // https://stackoverflow.com/questions/59410082/unable-to-view-angular-material-mat-tab-ink-bar-sometimes-in-angular-7
  ngAfterViewChecked(): void {
    if (this.childTabs) {
      this.childTabs.realignInkBar();
    }
  }

  // 页面高度撑满屏幕
  ngAfterViewInit(): void {
    this.windowHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowHeight = window.innerHeight;
  }

  // 搜索
  filterData() {
    const selectedMaxBedroomsData = this.selectedMaxBedrooms == 0 ? this.defaultFilterParams.bedRoom[this.defaultFilterParams.bedRoom.length - 1].value : this.selectedMaxBedrooms;
    if (this.selectedMinBedrooms > selectedMaxBedroomsData) {
      this.toastrService.error('Max Bedrooms must be greater than Min Bedrooms');
      return;
    }
    const bedRoomParams = this.filterParams.bedRoom.filter((bedRoom) => bedRoom.value >= this.selectedMinBedrooms && bedRoom.value <= selectedMaxBedroomsData).map((bedRoom) => bedRoom.value);

    const selectedMaxBathroomsData = this.selectedMaxBathrooms == 0 ? this.defaultFilterParams.bathRoom[this.defaultFilterParams.bathRoom.length - 1].value : this.selectedMaxBathrooms;
    if (this.selectedMinBathrooms > selectedMaxBathroomsData) {
      this.toastrService.error('Max Bathrooms must be greater than Min Bathrooms');
      return;
    }
    const bathRoomParams = this.filterParams.bathRoom.filter((bathRoom) => bathRoom.value >= this.selectedMinBathrooms && bathRoom.value <= selectedMaxBathroomsData).map((bathRoom) => bathRoom.value);

    const selectedMaxCarspaceData = this.selectedMaxCarspace == 0 ? this.defaultFilterParams.carParking[this.defaultFilterParams.carParking.length - 1].value : this.selectedMaxCarspace;
    if (this.selectedMinCarspace > selectedMaxCarspaceData) {
      this.toastrService.error('Max Cars Space must be greater than Min Cars Space');
      return;
    }
    const carParkingParams = this.filterParams.carParking.filter((carParking) => carParking.value >= this.selectedMinCarspace && carParking.value <= selectedMaxCarspaceData).map((carParking) => carParking.value);
    const aspectParams = this.filterParams.aspect.filter((aspect) => aspect.isChecked).map((aspect) => aspect.value);
    const statusParams = [].concat(...this.filterParams.status.filter((status) => status.isChecked).map((status) => status.value));

    const selectedMaxPriceRangeData = this.selectedMaxPriceRange == 0 ? this.defaultFilterParams.priceRange[this.defaultFilterParams.priceRange.length - 1].value : this.selectedMaxPriceRange;
    if (this.selectedMinPriceRange > selectedMaxPriceRangeData) {
      this.toastrService.error('Max Price Range must be greater than Min Price Range');
      return;
    }

    const priceRangeParams = this.filterParams.priceRange.filter((price) => price.value >= this.selectedMinPriceRange && price.value <= selectedMaxPriceRangeData).map((price) => price.value);


    const filterBuildings = JSON.parse(JSON.stringify(this.buildings));

    filterBuildings.map(building => {
      building.properties = building.properties.filter((property) => {
        // filter by bedRoom
        console.log(bedRoomParams, 'bedRoomParams');
        console.log(bathRoomParams, 'bathRoomParams');
        console.log(priceRangeParams, 'priceRangeParams');
        // if (
        //     bedRoomParams.length > 0 &&
        //     !bedRoomParams.includes(0) &&
        //     !bedRoomParams.includes(property.bedRoom) &&
        //     (!bedRoomParams.includes(13) || (bedRoomParams.includes(13) && property.bedRoom < 13))
        // ) {
        //     return false;
        // }
        if (bedRoomParams.length > 1) {
          if (property.bedRoom < bedRoomParams[0] || property.bedRoom > bedRoomParams[bedRoomParams.length - 1]) {
            return false;
          }
        }

        // filter by bathRoom
        // if (
        //     bathRoomParams.length > 0 &&
        //     !bathRoomParams.includes(0) &&
        //     !bathRoomParams.includes(property.bedRoom) &&
        //     (!bathRoomParams.includes(5) || (bathRoomParams.includes(5) && property.bedRoom < 5))
        // ) {
        //     return false;
        // }
        if (bathRoomParams.length > 1) {
          if (property.bathRoom < bathRoomParams[0] || property.bathRoom > bathRoomParams[bathRoomParams.length - 1]) {
            return false;
          }
        }


        // filter by carParking
        // if (
        //     carParkingParams.length > 0 &&
        //     !carParkingParams.includes(0) &&
        //     !carParkingParams.includes(property.bedRoom) &&
        //     (!carParkingParams.includes(5) || (carParkingParams.includes(5) && property.carParking < 5))
        // ) {
        //     return false;
        // }
        if (carParkingParams.length > 1) {
          if (property.carParking < carParkingParams[0] || property.carParking > carParkingParams[carParkingParams.length - 1]) {
            return false;
          }
        }

        // filter by price
        if (priceRangeParams.length > 1) {
          if (property.price < priceRangeParams[0] || property.price > priceRangeParams[priceRangeParams.length - 1]) {
            return false;
          }
        }

        // filter by aspect
        if (aspectParams.length > 0 && !aspectParams.includes(property.aspect)) {
          return false;
        }

        // filter by status
        if (statusParams.length > 0 && !statusParams.includes(property.status)) {
          return false;
        }

        // filter by keywords
        if (this.keywords && !property.unitNum.toLowerCase().includes(this.keywords.toLowerCase())) {
          return false;
        }

        return true;
      });
      return building;
    });

    const selected = this.selectedMinBedrooms !== 0 ||
      this.selectedMaxBedrooms !== 0 ||
      this.selectedMinBathrooms !== 0 ||
      this.selectedMaxBathrooms !== 0 ||
      this.selectedMinCarspace !== 0 ||
      this.selectedMaxCarspace !== 0 ||
      this.selectedMinPriceRange !== 0 ||
      this.selectedMaxPriceRange !== 0;

    this.isFiltered = (selected || JSON.stringify(this.filterParams) !== JSON.stringify(this.defaultFilterParams) || this.keywords !== '');

    console.log(this.filterParams, this.defaultFilterParams);

    this.updateSourceData(filterBuildings);
  }

  // 处理搜索条件的互斥
  checkFilterParams(params, item) {
    if (!item.isChecked) {
      return;
    }

    // any
    if (item.value === 0) {
      params.map((param) => {
        if (param.value !== 0) {
          param.isChecked = false;
        }
      });
    }

    if (item.value !== 0) {
      params.map((param) => {
        if (param.value === 0) {
          param.isChecked = false;
        }
      });
    }
  }

  getPropertiesByLevel(buildingId, level) {
    return this.dataSource.get(buildingId).data.filter((property) => property.level === level);
  }

  selectedPropertiesChange(buildingId, propertyId) {
    const selectedByBuildingId = this.dataSource.get(buildingId).data.filter((property) => property.isChecked === true);
    this.selectedProperties.forEach((selected, index) => {
      if (selected.id === propertyId) {
        this.selectedProperties.splice(index, 1);
      }
    });
    selectedByBuildingId.forEach((data, index) => {
      if (this.selectedProperties.filter((property) => property.id === data.id).length <= 0) {
        this.selectedProperties.push(data);
      }
    });
    this.currentBuildingId = buildingId;
    this.showStatusBar = this.selectedProperties.length > 0;
  }

  // 关闭批量修改状态bar
  closeStatusBar() {
    // 清空选中状态
    this.selectedProperties.map((property) => {
      property.isChecked = false;
      this.dataSource.get(property.project.id).data.map(data => {
        data.isChecked = false;
      });
      const buildingItem = this.dataSource.get(property.project.id);
      buildingItem.selection.clear();
    });
    this.showStatusBar = false;
    this.selectedProperties = [];
  }

  updateSourceData(buildings) {
    this.dataSourceCount = 0;
    buildings.map((building) => {
      this.dataSourceCount += building.properties.length;
      // 重新搜索，清空选中
      building.properties.map((property) => {
        property.isChecked = false;
      });

      const itemData: any = {
        data: building.properties ? building.properties.sort(this.compareUnit) : [], // 矩阵数据
        tableData: building.properties ? building.properties.sort(this.compareFloor) : [], // 表格数据
        selection: new SelectionModel<any>(true, []),
      };
      // Apartment 项目
      if (this.project.projectTypes[0].id === 3) {
        const levelSet = new Set();
        itemData.data.map((property) => levelSet.add(property.level));
        itemData.levelSet = levelSet;
      }

      this.dataSource.set(building.id, itemData);
    });
  }

  // 清空搜索参数
  clearFilterData() {
    this.filterParams = JSON.parse(JSON.stringify(this.defaultFilterParams));
    // this.matRangeSlider.resetFormGroup();
    // this.matRangeSlider.calculateFillBar();
    this.selectedMinBedrooms = 0;
    this.selectedMaxBedrooms = 0;
    this.selectedMinBathrooms = 0;
    this.selectedMaxBathrooms = 0;
    this.selectedMinCarspace = 0;
    this.selectedMaxCarspace = 0;
    this.selectedMinPriceRange = 0;
    this.selectedMaxPriceRange = 0;
    this.isFiltered = false;
    this.filterData();
  }

  stopPropagation($event: any) {
    $event.stopPropagation();
  }

  // 修改property dialog
  editProperty(building, property) {
    const dialogRef = this.dialog.open(EditPackagePropertyDialogComponent, {
      width: '95%',
      maxWidth: '1400px',
      data: {
        project: building,
        property
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(this.resetInit, 'editProperty');
      if (result) {
        this.isLoading = true;
        this.showStatusBar = false;
        this.ngOnInit();
        this.resetInit.emit();
      }
    });
  }

  // property 详情  dialog
  openDetailDialog(property) {
    const dialogRef = this.dialog.open(PropertyDetailDialogComponent, {
      height: '100%',
      panelClass: ['animate__animated', 'animate__slideInRight', 'animate__faster'],
      position: {right: '0'},
      autoFocus: false,
      data: {property, project: this.project},
    });

    // 修改property dialog
    dialogRef.componentInstance.editProperty.subscribe(data => {
      this.editProperty(this.project, property);
    });

    // 点击图片，打开大图
    dialogRef.componentInstance.onClickImage.subscribe(data => {
      const floorPlan = data.property.floorPlan;

      console.log(data.property);
      if (!floorPlan.images || !floorPlan.images.length) {
        return;
      }

      const images = [];
      floorPlan.images.map(image => {
        images.push({
          src: this.getFloorplanImageUrl(image.fileName),
        });
      });

      this.dialog.open(ImagePreviewComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        data: {
          images
        }
      });
    });
  }

  getFloorplanImageUrl(fileName: string, project?: any) {
    const projectCode = project ? project.projectCode : this.project.projectCode;
    return environment.SERVER_URL + 'images/' + projectCode + '/floor_plans/' + fileName;
  }

  // 添加 property
  openAddDialog() {
    const dialogRef = this.dialog.open(AddPropertyDialogComponent, {
      width: '800px',
      height: '800px',
      data: {project: this.project},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result && result.newProperty) {
        const building = this.buildings.find((building) => building.id === result.projectId);

        if (building) {
          if (!building.properties) {
            building.properties = [];
          }
          building.properties.push(result.newProperty);
          this.filterData();
        }
      }
    });
  }

  // 分配中介
  allocate() {
    const dialogRef = this.dialog.open(AllocateDialogComponent, {
      width: '416px',
      height: '650px',
      data: {
        project: this.project,
        selectedProperties: this.selectedProperties,
        agencyIds: this.agencyIds,
        isAloneProperty: false
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      this.agencyIds = [];
      this.closeStatusBar();
    });
  }

  // 显示floorplan 图片
  openFloorPlan(floorPlan, unitNumber) {
    const dialogRef = this.dialog.open(PropertyFpDialogComponent, {
      width: '800px',
      data: {floorPlan, unitNumber, projectCode: this.project.projectCode},
    });
  }

  // 更新状态
  openUpdateStatusDialog(targetStatus) {
    const dialogRef = this.dialog.open(UpdatePropertyStatusDialogComponent, {
      width: '400px',
      data: {
        properties: this.selectedProperties,
        projectId: this.currentBuildingId,
        targetStatus
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.properties) {
        // this.selectedProperties.forEach((property) => {
        //     property.isChecked = false;
        // });
        this.selectedProperties = [];

        const building = this.buildings.find((building) => building.id === result.projectId);

        building.properties = building.properties.map(property => result.properties.find(p => p.id === property.id) || property);
        this.filterData();

        this.showStatusBar = false;
        this.resetInit.emit();
      }
    });
  }

  isAllSelected(buidlingId) {
    const numSelected = this.dataSource.get(buidlingId).selection.selected.length;
    const numRows = this.dataSource.get(buidlingId).data.filter(property => property.status !== 6).length;

    return numSelected === numRows;
  }

  masterToggle(buildingId) {
    const buildingItem = this.dataSource.get(buildingId);
    if (this.isAllSelected(buildingId)) {
      buildingItem.selection.clear();
      buildingItem.data.filter(property => property.status !== 6).forEach((property) => {
        property.isChecked = false;
        this.selectedPropertiesChange(buildingId, property.id);
      });

    } else {
      buildingItem.data.filter(property => property.status !== 6).forEach((property) => {
        buildingItem.selection.select(property);
        property.isChecked = true;
        this.selectedPropertiesChange(buildingId, property.id);
      });
    }

  }

  checkboxLabel(buildingId, row?: any): string {
    if (!row) {
      return `${this.isAllSelected(buildingId) ? 'select' : 'deselect'} all`;
    }
    return `${this.dataSource.get(buildingId).selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  changeMode(mode) {
    this.mode = mode;
  }

  // 切换tab，因为building不同，所以关闭批量修改状态
  tabChanged($event) {
    // this.closeStatusBar()
  }

  compareFloor(a, b) {
    const levelA = a.level;
    const levelB = b.level;
    let comparison = 0;
    if (levelA < levelB) {
      comparison = 1;
    } else if (levelA > levelB) {
      comparison = -1;
    }
    return comparison;
  }

  compareUnit(a, b) {
    const unitA = a.unitNum;
    const unitB = b.unitNum;
    let comparison = 0;
    if (unitA > unitB) {
      comparison = 1;
    } else if (unitA < unitB) {
      comparison = -1;
    }
    return comparison;
  }

  // 获取状态
  getStatusLabel(status) {
    switch (status) {
      case 0:
        return 'unavailable';
      case 1:
        return 'available';
      case 2:
        return 'reserved'; // eoi
      case 3:
        return 'reserved';
      case 4:
        return 'processing'; // exchanage conditional
      case 5:
        return 'processing'; // unconditional
      case 6:
        return 'sold';
    }
  }

  transformLevel(level) {
    switch (level) {
      case -1:
        return 'GC';
      case -2:
        return 'GB';
      case -3:
        return 'GA';
      case -4:
        return 'G';
      case -5:
        return 'LG';
      case -6:
        return 'L';
      case -7:
        return 'B';
      case -8:
        return 'B1';
      case -9:
        return 'B2';
      case -10:
        return 'B3';
      case -11:
        return 'B4';
      case -12:
        return 'B5';
      default:
        return level;
    }
  }

  protected readonly parseFloat = parseFloat;
}
